<template>
  <div :class="$style['pt-withdraw-audit']">
    <pt-page-title title="提现审核" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey"></pt-page-title>
    <pt-page-menu-filter :tabs="typeTabs" v-model="selectTab" state="status"></pt-page-menu-filter>
    <pt-page-factor-filter :labels="withdrawTabLabels" isQueryRouter v-model="params" ref="filter" @Filter="filter">
        <el-button type="primary" @click="filter()">筛选</el-button>
        <el-button type="primary" @click="exportWithdraw" :loading="exportLoading">导出</el-button>
        <el-button type="primary" @click="exportHistoryWithdraw">导出历史</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
        <el-button type="primary" @click="batchReview">批量审核</el-button>
        <el-button type="primary" @click="batchReject">批量驳回</el-button>
        <!-- <el-button type="primary" @click="toBalanceManage">账户余额管理</el-button> -->
    </pt-page-factor-filter>
    <pt-withdraw-table :tableLabels="tableLabels" :paramsData="paramsData" :isSearch="isSearch" ref="table" :isFromRouter="isFromRouter"
    :class="$style['pt-withdraw-audit-table']"   @select="select" @selectAll="selectAll" :selectedAmount="selectedAmount">
    <template>
      <el-table-column v-if="isShowApprovalDate" label="审核时间">
        <template slot-scope="scope">
          {{scope.row.approval_date}}
        </template>
      </el-table-column>
      <el-table-column label="提现描述">
        <template slot-scope="scope">
          {{scope.row.statusDescription}}
        </template>
      </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
              <el-button type="text" @click="sampleRecollect(scope.row)" v-if="isApprove(scope.row)">审核通过</el-button>
              <el-button type="text" @click="rejectWithdraw(scope.row)" v-if="isReject(scope.row)">驳回</el-button>
              <el-button type="text" @click="returnWithdraw(scope.row)" v-if="isReturnWithdraw(scope.row)">回退</el-button>
              <el-button type="text" disabled v-if="scope.row.hasRolledBack">已回退</el-button>
            </template>
        </el-table-column>
    </template>
    </pt-withdraw-table>
    <el-dialog :visible="is_dialog" :title="dialog_title" :class="$style['review-coupon-dialog']" @close="closeDialog">
      <audit-review v-if="is_reject" @closeDialog="closeDialog" :ids="selectIds"></audit-review>
    </el-dialog>
  </div>
</template>

<script>
import ptWithdrawTable from './pt-withdraw-table/withData'
import { withdrawTabLabels, typeTabs, tableLabels } from './withdraw-manage'
import { emptyObject } from '@/utils/lifebankUtils'
import { cashCount } from '@/utils/formUtils'
import auditReview from './audit-review'

import { hasPermissions } from 'utils/permissions'
// 组件class前缀
const prefixCls = 'pt-withdraw-audit'
const approvalDateFilter = {
  label: '审核时间',
  type: 'time-slot',
  value: 'approveDate',
  startName: 'approveDateStart',
  endName: 'approveDateEnd'
}
const PERM_BALANCE_ROLLBACK = 'PERM_BALANCE_ROLLBACK'
const PERM_AUDIT_WITHDRAWALS = 'PERM_AUDIT_WITHDRAWALS'
export default {
  name: 'pt-withdraw-audit',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    },
    // 是否显示审核时间
    isShowApprovalDate () {
      return this.selectTab === 'PROCESSING' || this.selectTab === 'COMPLETED'
    },
    is_dialog () {
      return this.is_reject
    },
    balanceData () {
      return this.$refs.table.balance
    },
    HAS_PERM_BALANCE_ROLLBACK () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_BALANCE_ROLLBACK)
    },
    HAS_PERM_AUDIT_WITHDRAWALS () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_AUDIT_WITHDRAWALS)
    }
  },
  props: {
    tableParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    cityList: {
      type: Array,
      default: function () {
        return []
      }
    },
    exportLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      withdrawTabLabels: withdrawTabLabels,
      typeTabs: typeTabs,
      tableLabels: tableLabels,
      searchKey: '',
      selectTab: '',
      params: {},
      isSearch: '',
      isFromRouter: false,
      paramsData: {},
      selectRows: [],
      dialog_title: '提现驳回',
      is_reject: false,
      selectIds: [],
      selectedAmount: null
    }
  },
  components: {
    ptWithdrawTable,
    auditReview
  },
  watch: {
    cityList: {
      handler: function (val) {
        this.withdrawTabLabels.forEach(item => {
          if (item.value === 'city') {
            item.options = val
          }
        })
      }
    },
    selectTab: {
      handler: function (val) {
        for (var key in this.paramsData) {
          this.$delete(this.paramsData, key)
        }
        for (var key1 in this.params) {
          this.$delete(this.params, key1)
        }
        this.paramsData.status = val === 'ALL' ? null : val
        this.isFromRouter = false
        this.filterLabelsData()
      },
      immediate: true
    }
  },
  methods: {
    isReturnWithdraw (row) {
      return row.status === 'FAILED' && row.canRollBackBalance && (this.HAS_PERM_BALANCE_ROLLBACK || this.HAS_PERM_AUDIT_WITHDRAWALS)
    },
    isApprove (row) {
      return row.status === 'WAITING_FOR_APPROVAL' && this.HAS_PERM_AUDIT_WITHDRAWALS
    },
    isReject (row) {
      return row.status === 'WAITING_FOR_APPROVAL' && this.HAS_PERM_AUDIT_WITHDRAWALS
    },
    returnWithdraw (row) {
      this.$emit('addUserWalletBalance', row.id)
    },
    toBalanceManage () {
      this.$router.push('/balance-manage')
    },
    queryMerchantBalance () {
      this.$refs.table.queryMerchantBalance()
    },
    batchReject () {
      this.selectRows.forEach(item => {
        this.selectIds.push(item.id)
      })
      this.is_reject = true
    },
    closeDialog (val) {
      if (val) {
        this.getWithdrawList()
        this.queryMerchantBalance()
        this.select()
      }
      this.is_reject = false
    },
    rejectWithdraw (row) {
      this.selectIds = []
      this.selectIds.push(row.id)
      this.is_reject = true
    },
    filterLabelsData () {
      // 筛选条件是否包含审核时间
      let isArrayInclundApproval = JSON.stringify(this.withdrawTabLabels).indexOf(JSON.stringify(approvalDateFilter)) < 0
      if (this.isShowApprovalDate) {
        if (isArrayInclundApproval) {
          this.withdrawTabLabels.splice(1, 0, approvalDateFilter)
        }
      } else {
        if (!isArrayInclundApproval) {
          this.withdrawTabLabels.forEach((item, index) => {
            if (item.value === 'approveDate') {
              this.withdrawTabLabels.splice(index, 1)
            }
          })
        }
      }
    },
    select (row) {
      this.selectRows = []
      let rowsAmount = null
      if (row && row.length) {
        row.forEach(item => {
          this.selectRows.push(item)
          rowsAmount = rowsAmount ? rowsAmount + item.amount : item.amount
        })
      }
      this.selectedAmount = cashCount(rowsAmount, true)
    },
    selectAll (rows) {
      let rowsAmount = null
      if (rows && rows.length) {
        rows.forEach(item => {
          this.selectRows.push(item)
          rowsAmount = rowsAmount ? rowsAmount + item.amount : item.amount
        })
      }
      this.selectedAmount = cashCount(rowsAmount, true)
    },
    batchReview (rows) {
      if (this.selectRows && this.selectRows.length > 0) {
        let ids = []
        let totalAmount = 0
        this.selectRows.forEach(item => {
          totalAmount = totalAmount ? totalAmount + item.amount : item.amount
        })
        if (totalAmount > this.balanceData.balance) {
          this.$message({
            type: 'error',
            message: '您所选择的提现记录金额大于可提现余额，请先充值余额',
            duration: 5000
          })
          // this.$message.error('您所选择的提现记录金额大于可提现余额，请先充值余额')
        } else {
          this.$confirm('您是否确认批量审核', '确认审核', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' }).then(_ => {
            this.selectRows.forEach(item => {
              if (item.status === 'WAITING_FOR_APPROVAL') {
                ids.push(item.id)
              }
            })
            //   this.isBatch = true
            if (ids.length > 0) {
              this.$emit('withdrawalComplete', ids)
            } else {
              this.$message.error('您选择的提现数据均已被审核通过/驳回/审核处理中，请选择待审核的数据进行审核')
              this.$refs.table.clearSelection()
            }
          })
        }
      } else {
        this.$message.error('请勾选需要审核的奖励记录')
      }
    },
    sampleRecollect (row) {
      if (row.amount > this.balanceData.balance) {
        this.$message({
          type: 'error',
          message: '您所选择的提现记录金额大于可提现余额，请先充值余额',
          duration: 5000
        })
        // this.$message.error('您所选择的提现记录金额大于可提现余额，请先充值余额')
      } else {
        this.$confirm('确定审核通过该提现记录吗', '提现审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let ids = []
          ids.push(row.id)
          this.$emit('withdrawalComplete', ids)
        })
      }
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.paramsData.searchKey = val
      // this.isSearch = val
    },
    emptySearch (val) {
      this.$delete(this.searchKey, 'searchKey')
    },
    toDetail (val) {
      this.$router.push('/withdraw-audit/withdraw-detail/' + val.id)
    },
    cleanParams () {
      emptyObject(this.params)
      this.filter()
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (!isFromRouter) {
          this.searchKey = null
          if (this.params.searchKey) {
            this.$delete(this.params, 'searchKey')
          }
        }
        if (key === 'withdrawalsDate') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
        if (key === 'approveDate') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
        if (key === 'withdrawalsMoney') {
          this.params.moneyRangeStart = cashCount(this.params[key].moneyRangeStart)
          this.params.moneyRangeEnd = cashCount(this.params[key].moneyRangeEnd)
          this.$delete(this.params, key)
        }
      }
      if (this.params.status === 'ALL') {
        this.$delete(this.params, 'status')
      }
      // this.params = JSON.parse(JSON.stringify(this.params))
      this.paramsData = { status: this.paramsData.status, ...this.params }
      let paramsData = JSON.parse(JSON.stringify(this.paramsData))
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(paramsData)
      }
      if (this.paramsData.status === 'ALL') {
        this.$delete(this.paramsData, 'status')
      }

    //   this.paramsData = { ...this.params.createdDate, ...this.params }
    },
    getWithdrawList () {
      this.$refs.table.getWithdrawList()
    },
    exportWithdraw () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          for (var key in this.params) {
            if (!this.params[key]) {
              this.$delete(this.params, key)
            }
            if (key === 'withdrawalsDate') {
              this.$delete(this.params[key], 'index')
              this.params = { ...this.params, ...this.params[key] }
              this.$delete(this.params, key)
            }
          }
          if (this.selectTab !== 'ALL') {
            this.params.status = this.selectTab
          }
          // this.params.status = this.params.status === 'ALL' ? null : this.params.status
          this.params.searchKey = this.searchKey ? this.searchKey : null
          this.$emit('withdrawalsExport', this.params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryWithdraw () {
      this.$router.push('/export-history/withdraw-audit/?name=wallet_withdrawals_export')
    }
  },
  created () {
    this.selectTab = this.$route.query.status
    this.paramsData.status = this.selectTab && this.selectTab !== 'ALL' ? this.selectTab : null
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-withdraw-audit{
  :global{
    .el-table{
      border-top: 1px solid #edbe81;
       border-bottom: 1px solid #edbe81;
       .el-button{
         margin-left: 0;
         margin-right: 10px;
       }
    }
  }

}
</style>
